import { DataTable } from 'simple-datatables';
import { on } from 'delegated-events';
import scrollToElement from 'scroll-to-element';
import debounce from 'debounce';
import helpers from './helpers.js';

export default (function () {
  return {
    init() {
      // Tables

      const tables = document.querySelectorAll('table:not(.no-responsive)');

      if (tables.length) {
        [...tables].forEach((table, index) => {
          if (table.closest('.table-responsive') != null) return;
          const tableWrapper = document.createElement('div');

          if (table.querySelector('.tooltip')) {
            tableWrapper.className = 'table-responsive has-tooltip';
          } else {
            tableWrapper.className = 'table-responsive';
          }
          helpers.wrap(table, tableWrapper);
        });
      }

      // Fix potential issues with labels that can go longer than the cell height;
      let colapsableTableCells = document.querySelectorAll('table.table--collapse [data-th]');

      const adjustCell = () => {
        colapsableTableCells = document.querySelectorAll('table.table--collapse [data-th]');
        [...colapsableTableCells].forEach((cell, index) => {
          const before = window.getComputedStyle(cell, ':before');
          cell.style.height = null;
          if (helpers.breakpoint() !== 'mobile') return;
          const h = Math.ceil(parseInt(before.height, 10)) + 1;
          if (cell.offsetHeight < h) cell.style.height = `${h + 1}px`;
        });
      };

      if (colapsableTableCells.length) {
        adjustCell();

        window.addEventListener('resize', debounce(() => {
          adjustCell();
        }, 50, false));
      }

      const pageableTable = document.querySelectorAll('.js-table-paged');

      const checkPager = (dtInstance) => {
        dtInstance.pagers[0].classList.toggle('is-first-page', dtInstance.onFirstPage);
        dtInstance.pagers[0].classList.toggle('is-last-page', dtInstance.onLastPage);
      };

      if (pageableTable.length) {
        [...pageableTable].forEach((table) => {
          const labels = {};
          const infoLabel = table.getAttribute('data-info-label');
          if (infoLabel && infoLabel !== '') {
            labels.info = infoLabel;
          }
          const dataTable = new DataTable(table, {
            searchable: false,
            sortable: false,
            perPageSelect: false,
            perPage: helpers.breakpoint() === 'mobile' ? 5 : 10,
            labels,
          });
          dataTable.on('datatable.init', () => {
            checkPager(dataTable);
            on('click', '.dataTable-pagination .ellipsis a', (e) => {
              e.preventDefault();
            });
          });
          dataTable.on('datatable.page', (page) => {
            checkPager(dataTable);
            if (helpers.breakpoint() === 'mobile') {
              scrollToElement(dataTable.wrapper, {
                duration: 500,
                ease: 'in-out-quad',
                offset: -20,
              });
            }
          });
        });
      }
    },
  };
}());
